module.exports = __webpack_public_path__ + "e293096ae504191ca309bfc85297ae61.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Princess.png
// module id = 792
// module chunks = 0